import React, { useEffect, useState } from 'react';

import { useLazyQuery } from '@apollo/react-hooks';
import Avatar from 'avataaars';
import gql from 'graphql-tag';

import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

import styles from './UserAvatar.module.css';

interface IAvatar {
  accessoriesType?: string;
  clotheColor?: string;
  clotheType?: string;
  eyebrowType?: string;
  eyeType?: string;
  facialHairColor?: string;
  facialHairType?: string;
  graphicType?: string;
  hairColor?: string;
  mouthType?: string;
  pieceSize?: string;
  pieceType?: string;
  skinColor?: string;
  topType?: string;
}

const GET_AVATAR_CONFIGURATION = gql`
  query {
    avatar {
      getLoggedUserAvatar {
        configuration {
          key
          value
        }
      }
    }
  }
`;

const UserAvatar = (): JSX.Element => {
  const [avatarConfiguration, setAvatarConfiguration] = useState<IAvatar>();
  const [isLoaded, setIsLoaded] = useState(false);

  const [getAvatar, { loading }] = useLazyQuery(GET_AVATAR_CONFIGURATION, {
    context: { clientName: 'auth' },
    fetchPolicy: 'network-only',
    onCompleted: (response) => {
      const { configuration: configurations } = response.avatar.getLoggedUserAvatar || [];
      setAvatarConfiguration(
        configurations?.reduce((accumulator, configuration) => {
          const { key, value } = configuration;
          const updatedKey = `${key.substring(0, 1).toLowerCase() + key.substring(1)}`;

          return {
            ...accumulator,
            [updatedKey]: value,
          };
        }, {}),
      );
      setIsLoaded(true);
    },
  });

  useEffect(() => {
    getAvatar();
  }, []);

  return (
    <>
      {loading && <LoadingSpinner />}
      {isLoaded && (
        <div className={styles['c-avatar']}>
          <Avatar
            accessoriesType={avatarConfiguration?.accessoriesType}
            avatarStyle="Circle"
            clotheColor={avatarConfiguration?.clotheColor}
            clotheType={avatarConfiguration?.clotheType}
            eyebrowType={avatarConfiguration?.eyebrowType}
            eyeType={avatarConfiguration?.eyeType}
            facialHairColor={avatarConfiguration?.facialHairColor}
            facialHairType={avatarConfiguration?.facialHairType}
            graphicType={avatarConfiguration?.graphicType}
            hairColor={avatarConfiguration?.hairColor}
            mouthType={avatarConfiguration?.mouthType}
            pieceSize={avatarConfiguration?.pieceSize}
            pieceType={avatarConfiguration?.pieceType}
            skinColor={avatarConfiguration?.skinColor}
            topType={avatarConfiguration?.topType}
          />
        </div>
      )}
    </>
  );
};

export default UserAvatar;
